import morphdom from "morphdom";
import "./mini-cart-upsells";
import "./gift-note";

class MiniCart extends HTMLElement {
  constructor() {
    super();
    this.requestId = 1;
    this.closeButton = this.querySelector("[data-close]");
    this.content = this.querySelector(".mini-cart__content");

    this.closeButton?.addEventListener("click", () => this._close());
    this.addEventListener("click", (e) => {
      if (e.target.closest(".mini-cart__content")) return;

      this._close();
    });

    this.addEventListener("click", (e) => {
      const removeButton = e.target.closest("[data-remove]");

      if (!removeButton) return;

      this._updateQty({ key: removeButton.dataset.remove, quantity: 0 });
    });

    this.closeEsc = (e) => {
      if (e.key === "Escape") {
        this._close();
      }
    };

    document.addEventListener("keydown", this.closeEsc);

    document.addEventListener("mini-cart:open", () => this._open());
    document.addEventListener("mini-cart:close", () => this._close());
    document.addEventListener("updateCart", (e) => {
      const requestId = e.detail.data?.requestId;

      // Debounce - cancel update if another request is already in progress.
      if (requestId === this.requestId || !requestId) {
        this._updateCart(e.detail.cart.sections["mini-cart"]);
      }
    });

    this.addEventListener("change", (e) => {
      const item = e.target.closest("[data-item-key]");
      if (!item) return;

      this._updateQty({
        key: item.dataset.itemKey,
        quantity: parseInt(e.target.value, 10),
      });
    });

    if (new URL(window.location).searchParams.has("cart")) {
      this._open();
    }
  }

  disconnectedCallback() {
    document.removeEventListener("keydown", this.closeEsc);
  }

  _toggle() {
    this.hasAttribute("open") ? this._close() : this._open();
  }

  _open() {
    if (this.hasAttribute("open")) return;

    this.style.display = "block";
    window.requestAnimationFrame(() => {
      this.setAttribute("open", "");
      window.lockScroll(this);
      this.returnFocusEl = document.activeElement;
      window.trapFocus(this, this.closeButton);
    });
  }

  _close() {
    if (!this.hasAttribute("open")) return;

    this.removeAttribute("open");
    const onEnd = () => {
      this.removeEventListener("transitionend", onEnd);

      if (this.hasAttribute("open")) return;
      this.style.display = null;
      window.removeTrapFocus(this.returnFocusEl);
      window.unlockScroll(this);
    };
    this.addEventListener("transitionend", onEnd);
  }

  _updateQty({ key, quantity }) {
    window.changeCart(
      { id: key, quantity },
      {
        onError: () => this._refreshCart(),
        data: { requestId: ++this.requestId },
      },
    );
  }

  _refreshCart() {
    window
      .fetchPageData({ path: "/", options: { sectionId: "mini-cart" } })
      .then((markup) => this._updateCart(markup));
  }

  _updateCart(markup) {
    const html = new DOMParser().parseFromString(markup, "text/html");
    const sourceContent = html.querySelector(".mini-cart__content");
    new Promise((resolve) => {
      morphdom(this.content, sourceContent, {
        onNodeAdded: (node) => {
          if (node.nodeName === "SCRIPT") {
            var script = document.createElement("script");
            [...node.attributes].forEach((attr) => {
              script.setAttribute(attr.nodeName, attr.nodeValue);
            });

            script.innerHTML = node.innerHTML;
            node.replaceWith(script);
          }
        },
        onBeforeElUpdated: (fromEl, toEl) => {
          if (fromEl.nodeName === "SCRIPT" && toEl.nodeName === "SCRIPT") {
            var script = document.createElement("script");
            [...toEl.attributes].forEach((attr) => {
              script.setAttribute(attr.nodeName, attr.nodeValue);
            });

            script.innerHTML = toEl.innerHTML;
            fromEl.replaceWith(script);
            return false;
          }

          if (fromEl.nodeName === "IMG" && toEl.nodeName === "IMG") {
            if (fromEl.srcset !== toEl.srcset) {
              fromEl.replaceWith(toEl);
              return false;
            }
          }

          if (
            "forceUpdate" in fromEl.dataset ||
            "forceUpdate" in toEl.dataset
          ) {
            fromEl.replaceWith(toEl);
            return false;
          }

          if ("attributesOnly" in fromEl.dataset) {
            fromEl.dataset.attributesOnly.split(",").forEach((attribute) => {
              // skip blanks
              if (!attribute) return;

              fromEl.setAttribute(attribute, toEl.getAttribute(attribute));
            });

            return false;
          }
        },
      });
      requestAnimationFrame(resolve);
    }).then(() => {
      document.dispatchEvent(
        new CustomEvent("cart:updated", {
          detail: { sourceContent: sourceContent },
        }),
      );
    });
  }
}

if (!customElements.get("mini-cart")) {
  customElements.define("mini-cart", MiniCart);
}
